export default __webpack_public_path__ + "static/media/paper.0fb595f5.png";